export const API_NAMESPACE_CANDIDATE = "ex";
export const API_NAMESPACE_ETAB = "et";
